export default {
  title: "Guest List",
  description: "Manage your wedding guests",
  subtitle: "Manage your guest list and their invitations",
  addGuest: "Add Guest",
  editGuest: "Edit Guest",
  deleteGuest: "Delete Guest",
  guestDeleted: "Guest successfully deleted",
  guestCreated: "Guest successfully created",
  guestUpdated: "Guest successfully updated",
  noGuests: "No guests found",
  totalGuests: "{{count}} guests",
  confirmed: "{{count}} confirmed",
  declined: "{{count}} declined",
  pending: "{{count}} pending",
  search: "Search guests",
  addFirstGuest: "Add your first guest to get started",
  children: "Children",
  teens: "Teens",
  cancel: "Cancel",
  filters: {
    title: "Filters",
    clear: "Clear filters",
    status: {
      label: "Status",
      all: "All",
      confirmed: "Confirmed",
      pending: "Pending",
      declined: "Declined"
    },
    category: "Category",
    ageGroup: "Age Group",
    table: "Table",
    all: "All",
    reset: "Reset",
    resetFilters: "Reset Filters",
    events: {
      label: "Events",
      all: "All",
      ceremony: "Ceremony",
      reception: "Reception",
      both: "Both",
      allEvents: "All Events"
    },
    relation: "Relation",
    side: "Side",
    apply: "Apply",
    guestsearch: "Search for a guest",
    previous: "Previous",
    next: "Next",
    tableAssigned: "Table Assigned",
    group: {
      label: "Group",
      all: "All",
      family: "Family",
      friends: "Friends",
      colleagues: "Colleagues",
      other: "Other"
    },
    statusOptions: {
      all: "All",
      confirmed: "Confirmed",
      pending: "Pending",
      declined: "Declined"
    }
  },
  status: {
    pending: "Pending",
    confirmed: "Confirmed",
    declined: "Declined",
    tentative: "Tentative",
    maybe: "Maybe",
    invited: "Invited",
    notInvited: "Not Invited",
    "guests.status.pending": "Pending"
  },
  form: {
    title: "Guest Details",
    firstName: "First Name",
    lastName: "Last Name",
    email: "Email",
    phone: "Phone",
    address: "Address",
    status: "Status",
    category: "Category",
    ageGroup: "Age Group",
    dietaryRestrictions: "Dietary Requirements",
    notes: "Notes",
    plusOne: "Plus One",
    table: "Table",
    side: "Side",
    relation: "Relation",
    specialRequirements: "Special Requirements",
    children: "Children",
    submit: "Save",
    cancel: "Cancel",
    errors: {
      firstNameRequired: "First name is required",
      lastNameRequired: "Last name is required",
      emailInvalid: "Invalid email address"
    }
  },
  categories: {
    bride_groom: "Bride/Groom",
    family_close: "Close Family",
    family_extended: "Extended Family",
    witness: "Witness",
    honor_party: "Honor Party",
    friend_close: "Close Friend",
    friend: "Friend",
    colleague: "Colleague",
    acquaintance: "Acquaintance",
    other: "Other"
  },
  groups: {
    family: "Family",
    friends: "Friends",
    colleagues: "Colleagues",
    other: "Other"
  },
  ageGroups: {
    child: "Child",
    teen: "Teen",
    adult: "Adult",
    senior: "Senior"
  },
  import: {
    title: "Import Guests",
    description: "Import your guest list from a CSV file",
    template: "Download Template",
    upload: "Upload File",
    processing: "Processing...",
    success: "{{count}} guests imported successfully",
    error: "Error importing guests",
    formatError: "Invalid file format",
    instructions: "Download the template and documentation to understand the import format. Once your file is ready, select it to import.",
    downloadTemplate: "Download Template",
    downloadExcelTemplate: "Download Excel Template",
    downloadCsvTemplate: "Download CSV Template",
    downloadDocumentation: "Download Documentation",
    selectFile: "Select File",
    importButton: "Import",
    preview: {
      summary: "{{valid}} valid lines out of {{total}} ({{errors}} errors)",
      toggleDetails: "View error details",
      rowNumber: "Line {{row}}",
      retry: "Retry with another file"
    },
    errors: {
      title: "Import Error",
      invalidFileType: "File must be in CSV or Excel format",
      parseError: "Error reading file",
      excelParseError: "Error reading Excel file",
      fileReadError: "Error reading file",
      importFailed: "Import failed",
      noValidGuests: "No valid guests found in file",
      validationErrors: "{{count}} validation error(s) found:{{details}}",
      missingHeaders: "Required columns missing: {{headers}}",
      missingFirstName: "First name is required",
      missingLastName: "Last name is required",
      invalidStatus: "Invalid status: {{status}}",
      invalidCategory: "Invalid category: {{category}}",
      invalidSide: "Invalid side: {{side}}",
      invalidRelation: "Invalid relation: {{relation}}",
      invalidAgeGroup: "Invalid age group: {{ageGroup}}",
      invalidVip: "VIP value must be 'true' or 'false'",
      invalidPlusOne: "Plus one value must be 'true' or 'false'",
      invalidChildrenCount: "Children count must be a whole number",
      invalidTeenCount: "Teen count must be a whole number",
      missingPlusOneInfo: "Plus one information is incomplete",
      invalidEmail: "Email address is not valid"
    }
  },
  export: {
    title: "Export Guests",
    description: "Export your guest list to CSV",
    button: "Export",
    success: "Guest list exported successfully"
  },
  seatingPlan: {
    title: "Seating Plan",
    generate: "Generate seating plan",
    tables: "Tables",
    unassigned: "Unassigned guests",
    capacity: "Capacity",
    save: "Save plan",
    saveSuccess: "Seating plan saved successfully",
    honorTable: "Honor table",
    table: "Table {{number}}",
    config: "Configuration",
    honorTableCapacity: "Honor table capacity",
    standardTableCapacity: "Standard table capacity",
    numberOfTables: "Number of tables",
    honorTableSide: "Honor table side",
    options: "Options",
    prioritizeFamily: "Prioritize family",
    keepGroupsTogether: "Keep groups together",
    balanceTables: "Balance tables",
    separateConflicts: "Separate conflicts",
    backToConfig: "Back to configuration",
    both: "Both",
    bride: "Bride",
    groom: "Groom",
    configTitle: "Seating Plan Configuration",
    venueCapacity: "Venue Capacity",
    guestStats: "Guest Statistics",
    tableCapacities: "Table Capacities",
    totalCapacity: "Total Capacity",
    remainingSeats: "Remaining Seats",
    placementOptions: "Placement Options",
    avoidConflicts: "Avoid Conflicts",
    prioritizeHarmonies: "Prioritize Harmonies",
    keepFamiliesTogether: "Keep Families Together",
    balanceAgeGroups: "Balance Age Groups",
    specialTables: "Special Tables",
    childrenTableCapacity: "Children Table Capacity",
    teenTableCapacity: "Teen Table Capacity",
    stats: "Statistics",
    totalGuests: "Total Guests",
    children: "Children",
    teens: "Teens",
    generateSuccess: "Seating plan generated successfully",
    generateError: "Error generating seating plan",
    saveError: "Error saving seating plan",
    load: "Load Plan",
    loadSaved: "Saved Plans",
    separateFamilies: "Separate Families",
    mixSidesForSingles: "Mix Sides for Singles",
    separateFamiliesDesc: "Tries to place couples from different families at separate tables",
    mixSidesForSinglesDesc: "Favors mixing sides (bride/groom) for single guests",
    balanceTablesDesc: "Balances the number of guests per table",
    statsDetails: {
      totalTables: "Number of Tables",
      confirmedGuests: "Confirmed Guests",
      averagePerTable: "Average per Table"
    },
    standardTables: "Standard Tables",
    places: "places",
    placesEach: "places each",
    childrenTable: "children table",
    teenTable: "teen table",
    emptyTable: "Empty Table",
    noTables: "No tables created",
    noGuests: "No guests to place",
    dragAndDrop: "Drag and drop to modify placement",
    honorTableTooltip: "Table reserved for bride, groom, witnesses and close family",
    childrenTableTooltip: "Table reserved for children aged 0 to 12",
    teenTableTooltip: "Table reserved for teens aged 13 to 17",
    capacityTooltip: "Number of seats at this table",
    editTable: "Edit Table",
    deleteTable: "Delete Table",
    addTable: "Add Table",
    moveGuest: "Move Guest",
    filterByTable: "Filter by Table",
    filterByStatus: "Filter by Status",
    showUnassigned: "Show Unassigned Guests",
    print: "Print Plan",
    downloadPDF: "Download PDF",
    confirmDelete: "Are you sure you want to delete this table?",
    confirmReset: "Are you sure you want to reset the seating plan?",
    tableSaved: "Table saved successfully",
    tableDeleted: "Table deleted successfully",
    guestMoved: "Guest moved successfully",
    errors: {
      honorTableTooSmall: "Honor table ({{capacity}} seats) is too small to accommodate all VIPs ({{required}} people)",
      insufficientCapacity: "Insufficient total capacity ({{capacity}} seats) for {{guests}} guests"
    },
    autoTableCount: "Estimated number of tables: {{tables}}",
    generationSummary: "Plan generated with {{tables}} tables for {{guests}} guests (total capacity: {{capacity}} seats)",
    guestDistribution: "Distribution by Category",
    sideDistribution: "Distribution by Side",
    statusDistribution: "Distribution by Status",
    ageDistribution: "Distribution by Age",
    total: "Total",
    confirmedGuests: "Confirmed Guests",
    honorTableHelp: "Number of seats at the honor table (bride, groom, parents, witnesses)",
    standardTableHelp: "Number of seats at standard tables",
    honorTableSideHelp: "Side to prioritize for the honor table",
    prioritizeFamilyHelp: "Places close family at the honor table first",
    keepGroupsTogetherHelp: "Tries to keep guest groups at the same table",
    balanceTablesHelp: "Balances the number of guests and their distribution at each table",
    separateConflictsHelp: "Avoids placing conflicting guests at the same table",
    planName: "Plan Name",
    editPlanName: "Edit Name",
    planNamePlaceholder: "Seating plan name",
    savedSuccessfully: "Seating plan saved successfully",
    loadExisting: "Load Existing Plan"
  },
  tableAssigned: "Table {{number}}",
  unnamed: "Unnamed",
  ageGroup: "Age Group",
  categoryOptions: {
    bride_groom: "Bride/Groom",
    family_close: "Close Family",
    family_extended: "Extended Family",
    witness: "Witness",
    honor_party: "Honor Party",
    friend_close: "Close Friend",
    friend: "Friend",
    colleague: "Colleague",
    acquaintance: "Acquaintance",
    other: "Other"
  },
  ageGroupOptions: {
    child: "Child",
    teen: "Teen",
    adult: "Adult",
    senior: "Senior",
    ageRange: {
      adult: "(18-64 years)",
      senior: "(65+ years)"
    }
  },
  vip: "VIP",
  bulkActions: {
    selectMultiple: "Multiple selection",
    exitSelection: "Exit selection",
    selectedCount: "{{count}} guest(s) selected",
    selectAll: "Select all",
    deselectAll: "Deselect all",
    markConfirmed: "Mark confirmed",
    markPending: "Mark pending",
    markDeclined: "Mark declined",
    confirmStatusUpdate: "Confirm status change",
    confirmStatusUpdateMessage: "Are you sure you want to change the status of {{count}} guest(s) to \"{{status}}\"?",
    statusUpdateSuccess: "Status updated for {{count}} guest(s)",
    statusUpdateError: "Error updating status",
    selected: "Selected",
    selectThis: "Select this guest"
  },
  guests: {
    statusLabels: {
      pending: "Pending",
      confirmed: "Confirmed",
      declined: "Declined",
      invited: "Guest",
      maybe: "Maybe",
      not_invited: "Not invited"
    }
  },
  pagination: {
    showing: "Showing {{from}} to {{to}} of {{total}} guests",
    previous: "Previous",
    next: "Next"
  },
  columns: {
    name: "Name",
    email: "Email",
    category: "Category",
    table: "Table",
    status: "Status",
    children: "Children",
    actions: "Actions",
    plusOne: "Plus One",
    phone: "Phone",
    group: "Group"
  },
  table: {
    name: "Name",
    email: "Email",
    phone: "Phone",
    status: "Status",
    relation: "Relation",
    side: "Side",
    children: "Children",
    actions: "Actions",
    headers: {
      name: "Name",
      email: "Email",
      group: "Group",
      events: "Events",
      plusOne: "+1",
      status: "Status",
      actions: "Actions"
    },
    noEmail: "No Email",
    noData: "-",
    plusOneOf: "Plus One of {{name}}",
    childrenOf: "{{count}} Child(ren) of {{name}}",
    teensOf: "{{count}} Teen(s) of {{name}}"
  },
  sharing: {
    share: "Share",
    title: "Share Guests",
    defaultMessage: "I have shared guests with you",
    recipientEmail: "Recipient Email",
    emailPlaceholder: "Enter recipient email",
    recipientName: "Recipient Name",
    namePlaceholder: "Enter recipient name",
    message: "Message",
    messagePlaceholder: "Enter your message",
    accessLevel: "Access Level",
    readOnly: "Read Only",
    edit: "Edit",
    success: "Invitation sent successfully"
  },
  relation: {
    family: "Family",
    friend: "Friend",
    colleague: "Colleague",
    other: "Other",
    parent: "Parent",
    sibling: "Sibling",
    cousin: "Cousin",
    uncleAunt: "Uncle/Aunt",
    grandparent: "Grandparent"
  },
  side: {
    hostA: "Host A",
    hostB: "Host B",
    both: "Both",
    none: "None",
    bride: "Bride",
    groom: "Groom"
  },
  actions: {
    addGuest: "Add Guest",
    editGuest: "Edit Guest",
    deleteGuest: "Delete Guest",
    importGuests: "Import Guests",
    exportGuests: "Export Guests",
    sendInvitation: "Send Invitation",
    resendInvitation: "Resend Invitation",
    import: "Import",
    export: "Export",
    search: "Search...",
    sendReminder: "Send Reminder",
    edit: "Edit",
    delete: "Delete",
    createInvitation: "Create Invitation",
    cancel: "Cancel",
    save: "Save",
    view: "View",
    filter: "Filter"
  },
  messages: {
    guestAdded: "Guest added successfully",
    guestUpdated: "Guest updated successfully",
    guestDeleted: "Guest deleted successfully",
    guestsImported: "Guests imported successfully",
    guestsExported: "Guests exported successfully",
    invitationSent: "Invitation sent successfully",
    noGuests: "No guests",
    addFirstGuest: "Add your first guest",
    createSuccess: "Guest added successfully",
    updateSuccess: "Guest updated successfully",
    deleteSuccess: "Guest deleted successfully",
    deleteConfirm: "Are you sure you want to delete this guest?",
    error: "An error occurred",
    reminderSent: "Reminder sent successfully",
    importSuccess: "Import completed successfully",
    exportSuccess: "Export completed successfully"
  },
  modal: {
    title: "Guest",
    guestDetails: "Guest Details",
    firstName: "First Name",
    lastName: "Last Name",
    email: "Email",
    phone: "Phone",
    status: "Status",
    category: "Category",
    side: "Side",
    ageGroup: "Age Group",
    plusOne: "Plus One",
    plusOneFirstName: "Plus One First Name",
    plusOneLastName: "Plus One Last Name",
    dietaryRestrictions: "Dietary Restrictions",
    dietaryRestrictionsPlaceholder: "Vegetarian, allergies, gluten intolerance...",
    notes: "Notes",
    childrenCount: "Number of children (0-12 years)",
    teenCount: "Number of teens (13-17 years)",
    personalInfo: "Personal Information",
    accompaniment: "Plus One and Children",
    children: "Children",
    relation: "Relation",
    attendance: "Attendance",
    confirmDelete: "Are you sure you want to delete this guest?",
    categoryOptions: {
      bride_groom: "Bride & Groom",
      family_close: "Close Family",
      family_extended: "Extended Family",
      witness: "Witness",
      honor_party: "Wedding Party",
      friend_close: "Close Friend",
      friend: "Friend",
      colleague: "Colleague",
      acquaintance: "Acquaintance",
      other: "Other"
    },
    relationOptions: {
      parent: "Parent",
      sibling: "Sibling",
      cousin: "Cousin",
      friend: "Friend",
      colleague: "Colleague",
      other: "Other"
    },
    sideOptions: {
      bride: "Bride",
      groom: "Groom",
      both: "Both",
      none: "None"
    },
    statusOptions: {
      pending: "Pending",
      confirmed: "Confirmed",
      declined: "Declined"
    },
    ageGroupOptions: {
      adult: "Adult",
      senior: "Senior",
      ageRange: {
        adult: "(18-64 years)",
        senior: "(65+ years)"
      }
    },
    confirm: "Confirm",
    decline: "Decline",
    specialRequirements: "Special Requirements",
    specialNeeds: "Special Needs",
    specialNeedsPlaceholder: "Accessibility, special needs...",
    seatingPlanParams: "Seating Plan Parameters",
    selectCategory: "Select Category",
    selectRelation: "Select Relation",
    selectSide: "Select Side",
    selectAgeGroup: "Select Age Group",
    noEmail: "No Email",
    close: "Close",
    successDescription: "Shared successfully",
    error: "Error",
    tableAssigned: "Table {{number}}",
    unnamed: "Unnamed",
    vip: "VIP"
  },
  errors: {
    loadWedding: "Error loading wedding data",
    loadGuests: "Error loading guests",
    noWeddingFound: "No wedding found",
    generateSeatingPlan: "Error generating seating plan",
    saveSeatingPlan: "Error saving seating plan",
    addGuest: "Error adding guest",
    updateGuest: "Error updating guest",
    deleteGuest: "Error deleting guest",
    sendReminder: "Error sending reminder",
    import: "Error during import",
    export: "Error during export"
  },
  fields: {
    firstName: "First Name",
    lastName: "Last Name",
    status: "Status",
    category: "Category",
    relation: "Relation",
    side: "Side"
  },
  category: {
    family: "Family",
    friend: "Friend",
    colleague: "Colleague",
    other: "Other"
  },
  guestsWidget: {
    title: "Guests",
    subtitle: "Manage your guests",
    total: "Total",
    confirmed: "Confirmed",
    pending: "Pending",
    declined: "Declined",
    manage: "Manage Guests",
    empty: "No Guests",
    addGuest: "Add Guest"
  },
  validation: {
    required: {
      lastName: "Last name is required",
      firstName: "First name is required"
    },
    invalid: {
      email: "Invalid email"
    }
  },
  stats: {
    title: "Statistics",
    label: "Guest Statistics",
    total: "Total Guests",
    confirmed: "Confirmed",
    pending: "Pending",
    declined: "Declined",
    responseRate: "Response Rate"
  },
  empty: {
    noGuests: {
      title: "No Guests",
      description: "Start by adding your first guest."
    },
    noResults: {
      title: "No guests match the filters",
      description: "Modify your filters to see more results."
    }
  },
  analytics: {
    title: "Guest Analytics",
    totalGuests: "Total Guests",
    confirmationRate: "Confirmation Rate",
    adultsVsMinors: "Adults vs Minors",
    rsvpStatus: "RSVP Status",
    demographics: "Demographics",
    guestTypes: "Guest Breakdown"
  },
  settings: {
    rsvpSettings: "RSVP Settings"
  }
};
